import * as React from "react";
import Autoplay from "embla-carousel-autoplay";
import ODDBALL from "../assets/imgs/oddballs.webp";
/* import palillos from "../assets/imgs/pickem.webp";
import sketchone from "../assets/imgs/sketch1.jpeg"; */
import promone from "../assets/imgs/ecom2.jpeg";
import promotwo from "../assets/imgs/Promo2.jpeg";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../components/ui/carousel";

const carouselItems = [
  {
    image: ODDBALL,
    title: "Market Research",
    linking: "https://checkout.wompi.co/l/3IpI18",
    description: "Acquire our market research services we provide you with the data you need to understand your target audience and make informed business decisions.",
  },
  {
    image: promone,
    title: "Framer Website",
    linking: "https://checkout.wompi.co/l/z5XUIc",
    description: "Acquire our Framer website templates and unlock the power of customization, you can customize it to create your own unique website.",
  },
  {
    image: promone,
    title: "Webflow Website",
    linking: "https://checkout.wompi.co/l/z5XUIc",
    description: "Acquire our Webflow website templates and unlock the power of customization, you can customize it to create your own unique website.",
  },
  {
    image: promone,
    title: "Website sketch Aesthetic",
    linking: "https://checkout.wompi.co/l/VPOS_MJRNLU",
    description: "Acquire our React template that you can customize anytime. Personalized for your own purpose, use it on your website with a unique aesthetic style and with a database added.",
  },
  {
    image: promone,
    title: "Ecommerce Basic Platform!",
    linking: "https://checkout.wompi.co/l/VPOS_MJRNLU",
    description: "Acquire our complete platform for your ecommerce purposes, you can add your products, manage your stock and get more visibility for your products.",
  },
  {
    image: promotwo,
    title: "Your product could be here!",
    linking: "https://checkout.wompi.co/l/VPOS_MJRNLU",
    description: "This is a visible space for your products, you can add your products here and get more visibility or if you need an independent site to sell it.",
  },
];

export function CarouselPlugin() {
  const plugin = React.useRef(
    Autoplay({ delay: 2000, stopOnInteraction: true })
  );

  return (
    <Carousel
      plugins={[plugin.current]}
      className="w-full max-w-xs mx-auto !carrupeque"
      onMouseEnter={plugin.current.stop}
      onMouseLeave={plugin.current.reset}
    >
      <CarouselContent>
        {carouselItems.map((item, index) => (
          <CarouselItem key={index}>
            <div className="p-1">
              <Card>
                <CardContent className="flex flex-col items-center justify-center p-3">
                  <img src={item.image} alt={`Carousel item ${index + 1}`} className=" w-auto h-auto object-cover rounded-sm hover:scale-110 ease-in-out duration-500 hover:rounded-lg" />
                  <h2 className="text-xl font-bold mb-2">{item.title}</h2>
                  <div className="flex flex-col items-center justify-center">
                    <div className="mb-2">
                    <p className="text-center text-xs">{item.description}</p>
                    </div>
                    <Button variant="primary" asChild size="sm" className="pointer-events-auto dark:bg-white shadow-lg shadow-indigo-500/5 hover:bg-zinc-900 borderbg-zinc-900 w-full">
                      <a className="text-lg text-bold text-emerald-500 underline-offset-* " href={item.linking}>
                        Buy
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  );
}

